/**
 * settingsCache — module-level mirror of the most recently fetched
 * /api/admin/settings doc. Used by feature hooks (e.g. useAdminFirehose
 * sound + WS gating) that don't own their own fetch loop.
 *
 * Synchronous reads with a sane default keep components simple — if the
 * cache is empty (first paint before the settings fetch returns), the
 * defaults match the backend DEFAULTS so the UI never flickers a wrong
 * value on load.
 */
const DEFAULTS = {
  admin_sound_enabled: true,
  admin_ws_enabled: true,
};

let _doc = { ...DEFAULTS };
const _subs = new Set();

export const settingsCache = {
  get(key) {
    if (key === undefined) return _doc;
    return _doc[key] !== undefined ? _doc[key] : DEFAULTS[key];
  },
  set(next) {
    if (!next || typeof next !== "object") return;
    _doc = { ...DEFAULTS, ..._doc, ...next };
    _subs.forEach((fn) => {
      try { fn(_doc); } catch (e) { console.warn("[settingsCache] subscriber threw:", e); }
    });
  },
  subscribe(fn) {
    _subs.add(fn);
    return () => _subs.delete(fn);
  },
};

export default settingsCache;
